(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adres-assistant"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-adres-assistant]:not([data-adres-assistant-ready])');

    roots.forEach((root) => {
      root.setAttribute('data-adres-assistant-ready', 'true');

      const configElement = root.querySelector('[data-adres-assistant-config]');
      const launcher = root.querySelector('[data-adres-assistant-launcher]');
      const dialog = root.querySelector('[data-adres-assistant-dialog]');
      const closeButton = root.querySelector('[data-adres-assistant-close]');
      const messages = root.querySelector('[data-adres-assistant-messages]');
      const form = root.querySelector('[data-adres-assistant-form]');
      const input = root.querySelector('[data-adres-assistant-input]');
      const sendButton = root.querySelector('[data-adres-assistant-send]');
      const cartSummary = root.querySelector('[data-adres-assistant-cart-summary]');

      if (!configElement || !launcher || !dialog || !closeButton || !messages || !form || !input || !sendButton) {
        return;
      }

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        launcher.hidden = true;
        return;
      }

      let moneyFormatter;
      try {
        moneyFormatter = new Intl.NumberFormat(config.locale || document.documentElement.lang || 'tr-TR', {
          style: 'currency',
          currency: config.currency || 'TRY',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } catch (error) {
        moneyFormatter = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: 'TRY',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      const trustedProductHosts = new Set(
        (config.trustedProductHosts || []).filter(Boolean).map((host) => String(host).toLowerCase())
      );
      trustedProductHosts.add(window.location.hostname.toLowerCase());

      let sessionId = readSessionId();
      let lastProducts = [];
      let isSending = false;
      let cartLoaded = false;
      let previousFocus = null;

      function createSessionId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
        return `assistant-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      }

      function readSessionId() {
        try {
          const storedSession = window.sessionStorage.getItem('adresAssistantSessionId');
          if (storedSession) {
            return storedSession;
          }
        } catch (error) {
          return createSessionId();
        }
        return createSessionId();
      }

      function saveSessionId(value) {
        sessionId = value || sessionId;
        try {
          window.sessionStorage.setItem('adresAssistantSessionId', sessionId);
        } catch (error) {
          return;
        }
      }

      function transition(callback) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let callbackStarted = false;
        const runCallback = () => {
          if (callbackStarted) {
            return;
          }
          callbackStarted = true;
          callback();
        };
        if (document.startViewTransition && !reducedMotion) {
          try {
            const viewTransition = document.startViewTransition(runCallback);
            viewTransition.ready.catch(() => undefined);
            viewTransition.updateCallbackDone.catch(() => runCallback());
            viewTransition.finished.catch(() => undefined);
            return;
          } catch (error) {
            runCallback();
            return;
          }
        }
        runCallback();
      }

      function track(eventName, detail) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
      }

      function scrollMessages() {
        window.requestAnimationFrame(() => {
          messages.scrollTop = messages.scrollHeight;
        });
      }

      function normalizeAssistantReply(value) {
        return String(value || '')
          .replace(/\*\*([^*\r\n]+)\*\*/g, '$1')
          .replace(/\*\*/g, '');
      }

      function addMessage(role, text, status) {
        const message = document.createElement('div');
        const bubble = document.createElement('div');
        message.className = `adres-assistant__message adres-assistant__message--${role}`;
        if (status) {
          message.classList.add('adres-assistant__message--status');
        }
        bubble.className = 'adres-assistant__bubble';
        bubble.textContent = role === 'assistant'
          ? normalizeAssistantReply(text)
          : String(text || '');
        message.appendChild(bubble);
        messages.appendChild(message);
        scrollMessages();
        return message;
      }

      function addAction(message, label, href, primary) {
        let actions = message.querySelector('.adres-assistant__message-actions');
        if (!actions) {
          actions = document.createElement('div');
          actions.className = 'adres-assistant__message-actions';
          message.appendChild(actions);
        }
        const link = document.createElement('a');
        link.className = 'adres-assistant__action';
        if (primary) {
          link.classList.add('adres-assistant__action--primary');
        }
        link.href = href;
        link.textContent = label;
        actions.appendChild(link);
        return link;
      }

      function safeWhatsappUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          const hostname = url.hostname.toLowerCase();
          const expectedNumber = String(config.whatsappNumber || '').replace(/\D/g, '');
          if (url.protocol !== 'https:') {
            return null;
          }
          if (!['api.whatsapp.com', 'wa.me'].includes(hostname) || !expectedNumber) {
            return null;
          }
          const actualNumber = hostname === 'wa.me'
            ? url.pathname.replace(/\D/g, '')
            : String(url.searchParams.get('phone') || '').replace(/\D/g, '');
          if (actualNumber !== expectedNumber) {
            return null;
          }
          return url.href;
        } catch (error) {
          return null;
        }
      }

      function safeProductUrl(value) {
        if (typeof value !== 'string' || !value.trim() || value.length > 2048) {
          return null;
        }
        try {
          const url = new URL(value.trim(), window.location.origin);
          if (url.protocol !== 'https:' || url.username || url.password || url.port) {
            return null;
          }
          if (!trustedProductHosts.has(url.hostname.toLowerCase())) {
            return null;
          }

          const decodedPath = decodeURIComponent(url.pathname).normalize('NFC');
          const pathMatch = /^\/(?:([A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*)\/)?products\/([^/]+)\/?$/u.exec(decodedPath);
          if (!pathMatch) {
            return null;
          }

          const handle = pathMatch[2];
          if (!/^[\p{L}\p{N}][\p{L}\p{N}\p{M}_-]{0,254}$/u.test(handle)) {
            return null;
          }

          url.pathname = decodedPath;
          url.search = '';
          url.hash = '';
          return url;
        } catch (error) {
          return null;
        }
      }

      function safeImageUrl(value) {
        if (!value) {
          return null;
        }
        try {
          const url = new URL(value, window.location.origin);
          return url.protocol === 'https:' ? url.href : null;
        } catch (error) {
          return null;
        }
      }

      function formatPredictivePrice(value) {
        const numericPrice = Number(value);
        if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
          return '';
        }
        const formattedPrice = moneyFormatter.format(numericPrice);
        return String(config.currency || 'TRY').toUpperCase() === 'TRY'
          ? formattedPrice.replace('₺', 'TL')
          : formattedPrice;
      }

      function formatCartPrice(value) {
        const numericPrice = Number(value) / 100;
        if (!Number.isFinite(numericPrice)) {
          return '';
        }
        const formattedPrice = moneyFormatter.format(numericPrice);
        return String(config.currency || 'TRY').toUpperCase() === 'TRY'
          ? formattedPrice.replace('₺', 'TL')
          : formattedPrice;
      }

      function getProductImage(product) {
        if (!product || !product.image) {
          return null;
        }
        if (typeof product.image === 'string') {
          return safeImageUrl(product.image);
        }
        return safeImageUrl(product.image.url || product.image.src);
      }

      function normalizeProduct(product) {
        const url = safeProductUrl(product && product.url);
        const title = String((product && product.title) || '').trim().slice(0, 240);
        const id = String((product && product.id) || '').trim().slice(0, 80);
        if (!url || !title || !id) {
          return null;
        }
        return {
          id,
          title,
          url: url.href,
          path: url.pathname,
          price: formatPredictivePrice(product.price),
          image: getProductImage(product),
          available: product.available !== false
        };
      }

      function looksSensitive(value) {
        const text = String(value || '');
        const phonePattern = /(?:\+?90|0)?[\s.-]*\(?(?:5\d{2}|[2-4]\d{2})\)?[\s.-]*\d{3}[\s.-]*\d{2}[\s.-]*\d{2}/;
        const emailPattern = /[\w.+-]+@[\w-]+\.[\w.-]+/i;
        const personalAddressPattern = /\b(?:adresim|adresimi|ev adresim|evimin adresi|teslimat adresim|oturduğum|oturdugum|yaşadığım|yasadigim)\b/i;
        const addressHints = text.match(/\b(?:mahalle|mahallesi|cadde|caddesi|sokak|sokağı|sokagi|apartman|daire|adres)\b/gi) || [];
        const addressPattern = personalAddressPattern.test(text) || (
          addressHints.length > 0 && (addressHints.length >= 2 || (text.match(/\d/g) || []).length >= 3)
        );
        const cardPattern = /(?:^|\D)(?:\d[\s-]?){13,19}(?:\D|$)/;
        return phonePattern.test(text) || emailPattern.test(text) || addressPattern || cardPattern.test(text);
      }

      async function fetchJson(url, options, timeoutMs) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs || 10000);
        try {
          const response = await fetch(url, Object.assign({}, options || {}, {
            signal: controller.signal
          }));
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            const message = String(data.description || data.reply_text || data.error || config.strings.error).slice(0, 300);
            const requestError = new Error(message);
            requestError.status = response.status;
            throw requestError;
          }
          return data;
        } finally {
          window.clearTimeout(timeout);
        }
      }

      function updateCart(cart) {
        const itemCount = Number(cart && cart.item_count) || 0;
        const totalPrice = Number(cart && cart.total_price) || 0;
        const total = formatCartPrice(totalPrice);
        if (cartSummary) {
          cartSummary.textContent = itemCount > 0
            ? config.strings.cartSummaryTemplate
              .replace('__COUNT__', String(itemCount))
              .replace('__TOTAL__', total)
            : config.strings.cartEmpty;
        }
        document.querySelectorAll('#CartCount, [data-cart-count], .site-header__cart-count').forEach((element) => {
          element.textContent = String(itemCount);
        });
        document.dispatchEvent(new CustomEvent('adres-assistant:cart-updated', {
          detail: { itemCount, totalPrice }
        }));
      }

      async function refreshCart() {
        const cart = await fetchJson(config.cartJsonUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }, 8000);
        updateCart(cart);
        cartLoaded = true;
        return cart;
      }

      function renderPurchaseActions(message) {
        addAction(message, config.strings.viewCart, config.cartUrl, false);
        addAction(message, config.strings.checkout, config.checkoutUrl, true);
      }

      async function addProductToCart(product, button) {
        if (button.dataset.chooseOptions === 'true') {
          window.location.assign(product.url);
          return;
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        let keepDisabled = false;

        try {
          const productData = await fetchJson(`${product.path}.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }, 8000);
          const variants = Array.isArray(productData.variants) ? productData.variants : [];
          const availableVariants = variants.filter((variant) => variant && variant.available);

          if (!availableVariants.length) {
            addMessage('assistant', config.strings.soldOut);
            keepDisabled = true;
            return;
          }

          if (variants.length !== 1) {
            const optionMessage = addMessage('assistant', config.strings.optionRequired);
            addAction(optionMessage, config.strings.chooseOptions, product.url, true);
            button.dataset.chooseOptions = 'true';
            button.textContent = config.strings.chooseOptions;
            return;
          }

          const variant = availableVariants[0];
          const beforeCart = await refreshCart();
          const beforeQuantity = (beforeCart.items || []).reduce((total, item) => {
            return String(item.variant_id) === String(variant.id) ? total + Number(item.quantity || 0) : total;
          }, 0);

          if (beforeQuantity >= Number(config.maxQuantity || 2)) {
            addMessage('assistant', config.strings.maximum);
            keepDisabled = true;
            return;
          }

          await fetchJson(config.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variant.id, quantity: 1 }]
            })
          }, 10000);

          const afterCart = await refreshCart();
          const afterQuantity = (afterCart.items || []).reduce((total, item) => {
            return String(item.variant_id) === String(variant.id) ? total + Number(item.quantity || 0) : total;
          }, 0);

          if (afterQuantity <= beforeQuantity) {
            throw new Error(config.strings.cartError);
          }

          const addedText = config.strings.addedTemplate
            .replace('__PRODUCT__', product.title)
            .replace('__COUNT__', String(afterQuantity));
          const successMessage = addMessage('assistant', addedText);
          renderPurchaseActions(successMessage);
          keepDisabled = afterQuantity >= Number(config.maxQuantity || 2);
          track('adres_assistant_add_to_cart_verified', { product_id: product.id });

          if (config.pageType === 'cart') {
            addMessage('assistant', config.strings.cartRefreshing, true);
            window.setTimeout(() => window.location.reload(), 900);
          }
        } catch (error) {
          const message = error.name === 'AbortError' ? config.strings.timeout : (error.message || config.strings.cartError);
          addMessage('assistant', message);
          track('adres_assistant_add_to_cart_error', { product_id: product.id });
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = keepDisabled;
        }
      }

      function renderProductResults(products, query) {
        const normalizedProducts = products.map(normalizeProduct).filter(Boolean).slice(0, 5);
        lastProducts = normalizedProducts.map((product) => ({
          id: product.id,
          title: product.title,
          price: product.price,
          url: product.url,
          available: product.available
        }));

        if (!normalizedProducts.length) {
          const emptyMessage = addMessage('assistant', config.strings.noResults);
          addAction(emptyMessage, config.strings.whatsapp, config.whatsappUrl, true).target = '_blank';
          return;
        }

        const resultMessage = addMessage('assistant', config.strings.results);
        const productsList = document.createElement('div');
        productsList.className = 'adres-assistant__products';
        resultMessage.appendChild(productsList);

        normalizedProducts.forEach((product) => {
          const card = document.createElement('article');
          const imageLink = document.createElement('a');
          const titleLink = document.createElement('a');
          const price = document.createElement('div');
          const actions = document.createElement('div');
          const viewLink = document.createElement('a');
          const addButton = document.createElement('button');

          card.className = 'adres-assistant__product';
          imageLink.className = 'adres-assistant__product-image';
          imageLink.href = product.url;
          imageLink.setAttribute('aria-label', product.title);
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = product.title;
            image.loading = 'lazy';
            image.width = 240;
            image.height = 240;
            imageLink.appendChild(image);
          }

          titleLink.className = 'adres-assistant__product-title';
          titleLink.href = product.url;
          titleLink.textContent = product.title;
          price.className = 'adres-assistant__product-price';
          price.textContent = product.price;
          actions.className = 'adres-assistant__product-actions';
          viewLink.href = product.url;
          viewLink.textContent = config.strings.viewProduct;
          addButton.type = 'button';
          addButton.textContent = product.available ? config.strings.addToCart : config.strings.soldOut;
          addButton.disabled = !product.available;
          addButton.addEventListener('click', () => addProductToCart(product, addButton));

          actions.append(viewLink, addButton);
          card.append(imageLink, titleLink, price, actions);
          productsList.appendChild(card);
        });

        const allResultsUrl = new URL(config.searchUrl, window.location.origin);
        allResultsUrl.searchParams.set('q', `${query.replace(/\*+$/, '')}*`);
        allResultsUrl.searchParams.set('type', 'product');
        addAction(resultMessage, config.strings.showAll, allResultsUrl.href, false);
        track('adres_assistant_product_results', { result_count: normalizedProducts.length });
        scrollMessages();
      }

      async function searchProducts(query) {
        const normalizedQuery = String(query || '').trim().slice(0, 120);
        if (normalizedQuery.length < 2 || looksSensitive(normalizedQuery)) {
          return;
        }

        const statusMessage = addMessage('assistant', config.strings.searching, true);
        try {
          let resultQuery = normalizedQuery;
          let products = await fetchPredictiveProducts(resultQuery);
          const fallbackQuery = simplifyCatalogQuery(normalizedQuery);
          if (!products.length && fallbackQuery.length >= 2 && fallbackQuery !== normalizedQuery) {
            resultQuery = fallbackQuery;
            products = await fetchPredictiveProducts(resultQuery);
          }
          statusMessage.remove();
          renderProductResults(products, resultQuery);
        } catch (error) {
          statusMessage.remove();
          const errorMessage = addMessage('assistant', error.name === 'AbortError' ? config.strings.timeout : config.strings.productError);
          addAction(errorMessage, config.strings.whatsapp, config.whatsappUrl, true).target = '_blank';
        }
      }

      function simplifyCatalogQuery(value) {
        const conversationalTokenPattern = /^(?:(?:bak(?:ıyor|iyor)|ar(?:ıyor|iyor)|istiyor)[a-zçğıöşü]*|g[öo]ster(?:ir|ebilir)[a-zçğıöşü]*)$/i;
        const modalTokens = new Set([
          'mi', 'mı', 'mu', 'mü',
          'misin', 'mısın', 'musun', 'müsün',
          'misiniz', 'mısınız', 'musunuz', 'müsünüz'
        ]);
        const tokens = String(value || '').toLowerCase().match(/[0-9A-Za-zÇĞİÖŞÜçğıöşü]+/g) || [];
        return tokens
          .filter((token) => !modalTokens.has(token) && !conversationalTokenPattern.test(token))
          .join(' ')
          .slice(0, 120);
      }

      async function fetchPredictiveProducts(query) {
        const url = new URL(config.predictiveSearchUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const data = await fetchJson(url.href, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }, 8000);
        return (((data || {}).resources || {}).results || {}).products || [];
      }

      function extractReplyText(data) {
        if (data && typeof data.reply_text === 'string' && data.reply_text.trim()) {
          return data.reply_text.trim();
        }
        if (data && typeof data.reply === 'string') {
          return data.reply.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        }
        return config.strings.error;
      }

      async function handleResponseActions(data, message) {
        const actions = Array.isArray(data && data.actions) ? data.actions : [];
        let searchQuery = null;

        actions.forEach((action) => {
          if (!action || typeof action !== 'object') {
            return;
          }
          if (action.type === 'search_products' && typeof action.query === 'string') {
            searchQuery = action.query;
          }
          if (action.type === 'open_whatsapp') {
            const whatsapp = safeWhatsappUrl(action.url);
            if (whatsapp) {
              const link = addAction(message, String(action.label || config.strings.whatsapp), whatsapp, true);
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
            }
          }
        });

        if (searchQuery) {
          await searchProducts(searchQuery);
        }
      }

      function buildPayload(text) {
        const payload = {
          message: text,
          session_id: sessionId,
          page_type: config.pageType,
          catalog_products: lastProducts
        };
        if (config.currentProduct) {
          payload.product_url = config.currentProduct.url;
          payload.product_title = config.currentProduct.title;
          payload.product_price = config.currentProduct.price;
          payload.product_summary = config.currentProduct.summary;
          payload.product_available = Boolean(config.currentProduct.available);
        }
        return payload;
      }

      async function sendMessage(text) {
        const normalizedText = String(text || '').trim();
        if (!normalizedText || isSending) {
          return;
        }
        if (looksSensitive(normalizedText)) {
          addMessage('assistant', config.strings.privateData);
          input.value = '';
          input.focus();
          return;
        }

        addMessage('user', normalizedText);
        input.value = '';
        isSending = true;
        sendButton.disabled = true;
        form.setAttribute('aria-busy', 'true');
        const typingMessage = addMessage('assistant', config.strings.typing, true);

        try {
          const data = await fetchJson(config.endpoint, {
            method: 'POST',
            mode: 'cors',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(buildPayload(normalizedText))
          }, 25000);
          typingMessage.remove();
          if (data.session_id) {
            saveSessionId(String(data.session_id));
          }
          const assistantMessage = addMessage('assistant', extractReplyText(data));
          await handleResponseActions(data, assistantMessage);
          track('adres_assistant_message_success', { response_source: String(data.response_source || 'unknown') });
        } catch (error) {
          typingMessage.remove();
          const errorText = error.name === 'AbortError' ? config.strings.timeout : (error.message || config.strings.error);
          const errorMessage = addMessage('assistant', errorText);
          const whatsapp = safeWhatsappUrl(config.whatsappUrl);
          if (whatsapp) {
            const link = addAction(errorMessage, config.strings.whatsapp, whatsapp, true);
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
          }
          track('adres_assistant_message_error', { status: Number(error.status || 0) });
        } finally {
          isSending = false;
          sendButton.disabled = false;
          form.removeAttribute('aria-busy');
          input.focus();
        }
      }

      function openAssistant() {
        if (dialog.open) {
          return;
        }
        previousFocus = document.activeElement;
        transition(() => {
          dialog.showModal();
          document.documentElement.classList.add('adres-assistant-is-open');
          window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
        });
        if (!cartLoaded) {
          refreshCart().catch(() => undefined);
        }
        track('adres_assistant_open');
      }

      function closeAssistant() {
        if (!dialog.open) {
          return;
        }
        transition(() => dialog.close());
      }

      launcher.addEventListener('click', openAssistant);
      closeButton.addEventListener('click', closeAssistant);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('adres-assistant-is-open');
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeAssistant();
        }
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        sendMessage(input.value);
      });
      root.querySelectorAll('[data-adres-assistant-prompt]').forEach((button) => {
        button.addEventListener('click', () => {
          sendMessage(button.getAttribute('data-adres-assistant-prompt'));
        });
      });
      root.querySelectorAll('[data-adres-assistant-whatsapp]').forEach((link) => {
        link.addEventListener('click', () => track('adres_assistant_whatsapp_click'));
      });
      updateCart({
        item_count: config.cartItemCount,
        total_price: config.cartTotalPrice
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
